import React from "react";
import { useNavigate } from "react-router-dom";
import PageHeader from "../../components/PageHeader";
// @ts-ignore
import blogPosts from "../../data/blogs.json";
import { formatDate } from "../../utils/formatDate";

const BlogPost = ({
  id,
  title,
  date,
  image,
  categories,
  readingTime,
  onClick,
}) => {
  return (
    <div className="blog-post" onClick={() => onClick(id)}>
      <img src={image} alt={title} className="blog-thumbnail" />
      <div className="blog-info">
        <h2 className="blog-title">{title}</h2>
        <div className="blog-meta">
          <span className="blog-date">{formatDate(date)}</span>
          <span className="blog-reading-time">{readingTime}</span>
        </div>
        <div className="blog-tags">
          {categories.map((cat, i) => (
            <span key={i} className="tag">
              {cat}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
};

const Blog = () => {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate(-1);
  };

  const handlePostClick = (id) => {
    navigate(`/writing/${id}`);
  };

  return (
    <div className="full-screen-generic">
      <div className="about">
        <PageHeader title="Side Notebook" handleClick={handleBack} />
        <span className="blog-description">
          Welcome to my side notebook, where I explore, share what I’m learning,
          stash useful stuff, and document personal experiences. It’s a mix of
          personal notes, helpful finds, discoveries, little collections, and
          random deep dives into whatever catches my interest.
        </span>
        <div className="blog-list">
          {blogPosts.map((post) => (
            <BlogPost
              key={post.id}
              id={post.id}
              title={post.title}
              date={post.date}
              image={post.image}
              categories={post.categories}
              readingTime={post.readingTime} // raw content for reading time
              onClick={handlePostClick}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default Blog;
